// Language picker. Renders nothing until a second language is enabled in
// i18n.js's LOCALES, so it can sit in the header before any translation ships.
import { html, css, LitElement } from 'lit-element';
import { t, Localized, getLocale, setLocale, enabledLocales, LOCALES } from './i18n.js';
import { a11yStyles } from './a11y.js';

export class IntrivityLanguagePicker extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            select {
                font: inherit;
                color: #1a1a1a;
                background: transparent;
                border: 1px solid #1a1a1a;
                border-radius: 4px;
                padding: 2px 4px;
            }
        `];
    }

    render() {
        const current = getLocale();
        // A language previewed with ?lang= stays selectable even if disabled.
        const codes = enabledLocales();
        if (!codes.includes(current)) codes.push(current);
        if (codes.length < 2) return html``;

        return html`
            <label for="language" class="sr-only">${t('language.label')}</label>
            <select id="language" @change=${(e) => setLocale(e.target.value, { remember: true, userChosen: true })}>
                ${codes.map((code) => html`
                    <option value=${code} lang=${code} ?selected=${code === current}>${LOCALES[code].name}</option>
                `)}
            </select>
        `;
    }
}
if (!customElements.get('intrivity-language-picker')) customElements.define('intrivity-language-picker', IntrivityLanguagePicker);
